/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
    InsuranceTypeToJSONTyped,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface PatientInsurance
 */
export interface PatientInsurance {
    /**
     * 
     */
    type: InsuranceType;
    /**
     * Insurance state
     */
    state: string;
    /**
     * 
     */
    plan_number?: string;
    /**
     * 
     */
    medicaid_number?: string;
    /**
     * 
     */
    medicare_number?: string;
    /**
     * 
     */
    group_number?: string;
    /**
     * 
     */
    plan_name?: string;
    /**
     * Insurance payor name
     */
    payor: string;
}



/**
 * Check if a given object implements the PatientInsurance interface.
 */
export function instanceOfPatientInsurance(value: object): value is PatientInsurance {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('payor' in value) || value['payor'] === undefined) return false;
    return true;
}

export function PatientInsuranceFromJSON(json: any): PatientInsurance {
    return PatientInsuranceFromJSONTyped(json, false);
}

export function PatientInsuranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientInsurance {
    if (json == null) {
        return json;
    }
    return {
        
        'type': InsuranceTypeFromJSON(json['type']),
        'state': json['state'],
        'plan_number': json['plan_number'] == null ? undefined : json['plan_number'],
        'medicaid_number': json['medicaid_number'] == null ? undefined : json['medicaid_number'],
        'medicare_number': json['medicare_number'] == null ? undefined : json['medicare_number'],
        'group_number': json['group_number'] == null ? undefined : json['group_number'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'payor': json['payor'],
    };
}

export function PatientInsuranceToJSON(json: any): PatientInsurance {
    return PatientInsuranceToJSONTyped(json, false);
}

export function PatientInsuranceToJSONTyped(value?: PatientInsurance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': InsuranceTypeToJSON(value['type']),
        'state': value['state'],
        'plan_number': value['plan_number'],
        'medicaid_number': value['medicaid_number'],
        'medicare_number': value['medicare_number'],
        'group_number': value['group_number'],
        'plan_name': value['plan_name'],
        'payor': value['payor'],
    };
}

